import { forwardRef, ReactNode } from 'react';

import { StyledButtonGroup } from './ButtonGroup.styles';

export interface Props {
	children: ReactNode[];
	segmented?: boolean;
}

export const ButtonGroup = forwardRef<HTMLDivElement, Props>(({ children, segmented = false, ...props }, ref) => (
	<StyledButtonGroup ref={ref} segmented={segmented} {...props}>
		{children}
	</StyledButtonGroup>
));

ButtonGroup.displayName = 'ButtonGroup';
